export default [
  {
    path: '/enerji/dashboard',
    name: 'enerji-dashboard',

  },
]
